/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRadiusTopLeft = createReactComponent("outline", "radius-top-left", "IconRadiusTopLeft", [["path", { "d": "M5 19v-6a8 8 0 0 1 8 -8h6", "key": "svg-0" }]]);

export { IconRadiusTopLeft as default };
//# sourceMappingURL=IconRadiusTopLeft.mjs.map
